/*
 * Copyright (c) 2019-2025 AccelByte Inc. All Rights Reserved.
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { globalVar } from "./globalVar";

export function silentUrlBuilder(maybeAbsoluteUrl: string): URL | null {
  try {
    return new URL(maybeAbsoluteUrl);
  } catch (error) {
    return null;
  }
}

export function silentSearchParamsBuilder(usvString: string): URLSearchParams {
  try {
    return new URLSearchParams(usvString);
  } catch (error) {
    return new URLSearchParams("");
  }
}

export function trimSlashFromStringEnd(pathString: string) {
  let newString = pathString;
  while (newString[newString.length - 1] === "/") {
    newString = newString.slice(0, -1);
  }
  return newString;
}

export function trimSlashFromStringStart(pathString: string) {
  let newString = pathString;
  while (newString[0] === "/") {
    newString = newString.slice(1);
  }
  return newString;
}

export function trimSlashFromStringEdges(pathString: string) {
  return trimSlashFromStringStart(trimSlashFromStringEnd(pathString));
}

export function makeAbsolutePath(path: string) {
  return `/${trimSlashFromStringStart(path)}`;
}

export function combinePaths(...paths: string[]) {
  paths.forEach((path) => {
    if (typeof path !== "string") {
      throw new Error("combinePaths error: one of the path is not a string");
    }
  });
  return paths
    .map((path) => trimSlashFromStringEdges(path))
    .map((path) => path.split("/"))
    .reduce((path, nextPath) => path.concat(nextPath), [])
    .join("/");
}

export function combineURLPaths(urlString: string, ...paths: string[]) {
  const url = new URL(urlString);
  const { origin } = url;
  const pathname = combinePaths(url.pathname, ...paths);
  return new URL(pathname, origin).toString();
}

export const getStudioNamespaceFromSubdomain = (urlString?: string): string => {
  if (!globalVar.JUSTICE_API_URL) return "";
  const currentUrl = new URL(urlString ? urlString : window.location.href);
  const baseUrl = new URL(globalVar.JUSTICE_API_URL);
  if (currentUrl.hostname === baseUrl.hostname) return "";
  const [subdomain, ...restParts] = currentUrl.hostname.split(".");
  if (restParts.length === 0) return "";
  return subdomain;
};
export function prependUrlWithNamespace(url: URL, namespace: string) {
  const newUrl = new URL(url.toString());
  newUrl.hostname = `${namespace}.${url.hostname}`;
  return newUrl;
}
export function combineWithJusticeApiUrl(...paths: string[]): string {
  const url = new URL(combinePaths(...paths), globalVar.JUSTICE_API_URL);
  const namespace = getStudioNamespaceFromSubdomain();
  if (namespace) {
    return prependUrlWithNamespace(url, namespace).toString();
  }
  return url.toString();
}
